/**
 * Class lists the Emails page repeats: 44px buttons that go full width on
 * phones, 16px fields (so iOS doesn't zoom), and body copy.
 */

/** The amber "Yes, send it". */
export const BUTTON_CONFIRM =
  "inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-full bg-[color:var(--color-amber)] px-5 py-2 text-[15px] font-semibold text-[color:var(--color-bg)] transition-opacity hover:opacity-90 disabled:opacity-50";

/** The dark "Send to 14 people". */
export const BUTTON_SEND =
  "inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-full bg-[color:var(--color-ink)] px-5 py-2 text-[15px] font-semibold text-[color:var(--color-paper)] transition-opacity hover:opacity-90 disabled:opacity-50 sm:w-auto";

/** Outlined buttons: "Send me a test", "No, go back". */
export const BUTTON_SECONDARY =
  "inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-full border border-[color:var(--color-line-strong)] px-5 py-2 text-[15px] font-semibold text-[color:var(--color-ink)] transition-colors hover:border-[color:var(--color-ink)] disabled:opacity-50 sm:w-auto";

/** A full-width text button that opens or closes a group. */
export const BUTTON_DISCLOSURE =
  "flex min-h-11 w-full items-center justify-between gap-3 rounded-lg border border-[color:var(--color-line)] px-4 py-2.5 text-left text-[15px] font-semibold text-[color:var(--color-ink)] transition-colors hover:border-[color:var(--color-line-strong)]";

export const FIELD_INPUT =
  "min-h-11 w-full rounded-md border border-[color:var(--color-line-strong)] bg-[color:var(--color-bg)] px-3.5 py-2 text-[16px] text-[color:var(--color-ink)] outline-none transition-colors placeholder:text-[color:var(--color-ink-faint)] focus:border-[color:var(--color-amber)] sm:max-w-sm";

export const BODY_TEXT =
  "text-[16px] leading-relaxed text-[color:var(--color-ink-soft)]";

/** The small bold heading above a group of controls. */
export const STEP_HEADING =
  "text-[15px] font-semibold text-[color:var(--color-ink)]";
